// BlogContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import getCookie from '../helper/getCookie';
import eraseCookie from '../helper/eraseCookie';
import getDecryptData from '../helper/getDecryptData';
import io from "socket.io-client";
import axiosInstance, { weburl } from "../axiosInstance";
import messageAlertSound from "../user/assets/audio/message.mp3"; // Import the sound file

const socket = io(weburl);

const BlogContext = createContext();

export const BlogProvider = ({ children }) => {
    const [blogs, setBlogs] = useState([]);
    const [PRELOADED_DATA, setPRELOADED_DATA] = useState([]);
    const [PRELOADED_HEAD_DATA, setPRELOADED_HEAD_DATA] = useState([]);

    const [AllProducts, setAllProducts] = useState([]);
    const [AllCategoriess, setAllCategoriess] = useState([]);

    const clearAllItemsInCart = () => {
        setCartItems([]);
        localStorage.removeItem('cartItems');
    };

    const [isLoading, setIsLoading] = useState(true);

    const [Headers, setHeaders] = useState([]);
    const [LocationHeaders, setLocationHeaders] = useState([]);

    

    const [isHeader, setIsHeader] = useState(true);
    const [cartItems, setCartItems] = useState([]);

    const [promoCodeInfo, setPromoCodeInfo] = useState([]); // State to hold promo code information

    const [promoCode, setPromoCode] = useState(''); // State variable for promo code
    const [discount, setDiscount] = useState(0); // State variable for discount amount

    const [mypromoCode, setmyPromoCode] = useState(''); // State variable for promo code

    const [totalAmount, setTotalAmount] = useState(''); // Initialize with null
    const [PromoLoading, setPromoLoading] = useState(false); // Initialize with null

    const applyPromoCode = async (promoCode) => {
        setPromoLoading(true);
        try {
            // Make an API call to validate the promo code
            const response = await axiosInstance.post('/apply-promo', { promoCode });

            const { discount } = response.data; // Extract discount directly from response.data
            console.log('response.data', response.data);

            // Assuming success since a discount value is returned
            // Promo code is valid, apply discount
            setPromoCode(promoCode);
            setmyPromoCode(promoCode)
            setDiscount(discount);
            setPromoCodeInfo(prevState => ({
                ...prevState, // Copy existing state
                ...response.data // Merge with new data from response
            }));
            getTotalAmount(response.data)
            toast.success('Promo code applied successfully');

            console.log('Promo code applied successfully');
            console.log('promoCodeInfo', promoCodeInfo); // Log promoCodeInfo here

        } catch (error) {
            toast.error('Error applying promo code');

            // Handle errors
            console.error('Error applying promo code:', error);
        } finally {
            setPromoLoading(false);
        }

    };


    const base64Encode = (data) => {
        return btoa(JSON.stringify(data));
    };

    const base64Decode = (encodedData) => {
        return JSON.parse(atob(encodedData));
    };

  const [AllMessages, setAllMessages] = useState([]);

  
 const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const options = {
      month: "long", // Use 'long' to display the full month name
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

        const playMessageAlert = () => {
    const sound = new Audio(messageAlertSound);
    sound.play();
  };

  useEffect(() => {
    const decryptdatajson = getDecryptData();
    const userId = decryptdatajson?._id;

    socket.on("chat message", (message) => {
      console.log("messagemessagemessagemessage", message);
      if (message.type === "message") {
        console.log("get message");
        // Add date and time to the message object before updating state
        const messageWithDateTime = {
          ...message,
          time: formatTimestamp(new Date()),
        };

        setAllMessages((prevMessages) => {
          const newMessages = [...prevMessages, messageWithDateTime];
          return newMessages;
        });
        if (message.senderId !== userId) {
            playMessageAlert(); // Play sound alert if the message sender is the current user

           }
      }
     
  

    });

    return () => {
      socket.off("chat message");
    };
  }, []);


    const getHeader = async () => {

        if (window.PRELOADED_DATA_head) {
            setHeaders(window.PRELOADED_DATA_head);
            console.log('window.header', window.PRELOADED_DATA_head);
            setIsHeader(false);

        } else {
            try {

                const { data } = await axiosInstance.get(`/home-data`);
                setHeaders(data.homeData);
                console.log('data', data.homeData);

                setIsHeader(false);



            }
            catch (error) {
                console.log(error);
                setIsHeader(false);
            }
        }


    };

    // const getLocationHeader = async () => {

    //     if (window.PRELOADED_DATA_head) {
    //         setHeaders(window.PRELOADED_DATA_LOCATION_head);
    //         console.log('window.header.location', window.PRELOADED_DATA_head);
    //         setIsHeader(false);

    //     } else {
    //         try {

    //             const { data } = await axiosInstance.get(`/get-all-zones`);
    //          setLocationHeaders(data.Zones);
    //          console.log('data', data);
 
    //         }
    //         catch (error) {
    //             console.log(error);
    //          }finally{
    //           setIsHeader(false);

    //         }
    //     }


    // };
    
    const getLocationHeader = async () => {

        if (window.PRELOADED_DATA_head) {
            setHeaders(window.PRELOADED_DATA_LOCATION_head);
            console.log('window.header.location', window.PRELOADED_DATA_head);
            setIsHeader(false);

        } else {
            try {

                const { data } = await axiosInstance.get(`/get-all-zones-only`);
             setLocationHeaders(data.uniqueLocations);
             console.log('data', data);
 
            }
            catch (error) {
                console.log(error);
             }finally{
              setIsHeader(false);

            }
        }


    };
    

    const addItemToCart = async (item, qty) => {
        const existingItemIndex = cartItems.findIndex(cartItem => cartItem.id === item.id);


        if (existingItemIndex !== -1) {

            // Item already exists in cart, update its quantity
            const updatedCartItems = [...cartItems];

            const proQTY = await (updatedCartItems[existingItemIndex].quantity += qty);

            const prostockQTY = updatedCartItems[existingItemIndex].stock;

            if (proQTY >= prostockQTY) {
                console.log("proQTY", proQTY);
                console.log("prostockQTY", prostockQTY);
                (updatedCartItems[existingItemIndex].quantity -= qty);

                toast.error("Product out of stock.");

            } else {
                toast.success("Product Updated To Cart");

                updatedCartItems[existingItemIndex].quantity += qty;
                setCartItems(updatedCartItems);
                localStorage.setItem('cartItems', base64Encode(updatedCartItems));
            }


        } else {
            // Item doesn't exist in cart, add it with quantity 1
            toast.success("Product Added To Cart");

            const itemWithQuantity = { ...item, quantity: qty };
            const newCartItems = [...cartItems, itemWithQuantity];
            setCartItems(newCartItems);
            localStorage.setItem('cartItems', base64Encode(newCartItems));
        }
    };

    const removeItemFromCart = (itemId) => {
        const updatedCartItems = cartItems.filter(item => item.id !== itemId);
        setCartItems(updatedCartItems);
        localStorage.setItem('cartItems', base64Encode(updatedCartItems));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cartItems');
    };


    const updateItemQuantity_old = (itemId, quantity) => {
        const updatedCartItems = cartItems.map(item => {
            if (item.id === itemId) {
                if (quantity <= item.stock) {
                    console.log('quantity', quantity)
                    // Ensure quantity doesn't go below 1
                    const newQuantity = Math.max(quantity, 1);
                    getTotalAmount(promoCodeInfo)
                    return { ...item, quantity: newQuantity };
                } else {
                    toast.error("Product out of stock.")

                }

            }
            getTotalAmount(promoCodeInfo)
            return item;
        });
        setCartItems(updatedCartItems);

        localStorage.setItem('cartItems', base64Encode(updatedCartItems));

    };

    const updateItemQuantity = (itemId, quantity) => {
  const updatedCartItems = cartItems.map(item => {
    if (item.id === itemId) {
      if (quantity <= item.stock) {
        const newQuantity = Math.max(quantity, 1);
        return { ...item, quantity: newQuantity };
      } else {
        toast.error("Product out of stock.");
      }
    }
    return item;
  });

  setCartItems(updatedCartItems);
  localStorage.setItem('cartItems', base64Encode(updatedCartItems));
  getTotalAmount(promoCodeInfo);
};

 



    const getTotalUniqueItems = () => {
        const uniqueItems = new Set(cartItems.map(item => item.id));
        return uniqueItems.size;
    };

    const getTotalAmount = (promoCodeInfo) => {
        const total = cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);


        let discountedAmount = total;

        if (promoCodeInfo) {
            if (String(promoCodeInfo.type) === 'percentage') {
                discountedAmount = Math.round(total * ((promoCodeInfo.discount * 100) / 100));
                discountedAmount = total - discountedAmount;
            } else if (String(promoCodeInfo.type) === 'fixed') {
                discountedAmount = total - promoCodeInfo.discount;
                if (discountedAmount < 0) {
                    discountedAmount = 0;
                }
            }
        }

        setTotalAmount(discountedAmount);
        console.log('total', total)

    };



    const getTotalItems = () => {
        return cartItems.reduce((total, item) => total + item.quantity, 0);
    };



    useEffect(() => {
        const storedCartItems = localStorage.getItem('cartItems');

        if (storedCartItems) {
            setCartItems(base64Decode(storedCartItems));
        } else {
            setCartItems([]);
        }


        if (window.__PRELOADED_DATA__) {
            setPRELOADED_DATA(window.__PRELOADED_DATA__);
            console.log('window.__PRELOADED_DATA__', window.__PRELOADED_DATA__)
        }
    }, []);


    const removePromoCode = () => {
        setPromoCode('');
        setDiscount(0);
        setPromoCodeInfo(null);
    };




    const getUserAllPro = async () => {
        try {
            const response = await axiosInstance.get(`/all-products/`);

            setAllProducts(response.data.products);
            console.log('setAllProducts', response.data.products)

        } catch (error) {
            console.error('Error fetching user products:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const getUserAllCat = async () => {
        try {
            const response = await axiosInstance.get(`/all-category/`);

            setAllCategoriess(response.data.categories);
        } catch (error) {
            console.error('Error fetching user category:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const [layout, setLayout] = useState([]);

    const [isLayoutLoading, setIsLayoutLoading] = useState(true);


    const getData = async () => {
        try {
            const { data } = await axiosInstance.get(`/home-layout-data`);
            setLayout(data.homeLayout);
            setIsLayoutLoading(false); // Set loading state to false in case of an error
            console.log('data', data);

        }
        catch (error) {
            console.log(error);
            // toast.error("Error fetching Home layout!");
            setIsLayoutLoading(false); // Set loading state to false in case of an error
        }
    };

    const getUserBlogs = async () => {
        // try {
        //     const userId = localStorage.getItem('userId');
        //     const response = await axiosInstance.get(`http://localhost:8000/user-blogs/${userId}`);
        //     const { success, userBlog, message } = response.data;
        //     if (success) {
        //         setUserBlogs(userBlog.blogs);
        //     } else {
        //     }
        // } catch (error) {
        //     console.error('Error fetching user blogs:', error);
        // } finally {
        //     setIsLoading(false);
        // }
    };


    const dataAuth = async () => {
        const decryptdatajson = await getDecryptData();
        const id = decryptdatajson?._id;

        const credentials = {
            id: id,
        };
        const authuser = getCookie("token");
        if (!authuser) {
            return;
        }

        try {
            const { data } = await axiosInstance.post("/auth-user", credentials);

            const { success, existingUser } = data;
            if (success) {
                console.log(existingUser.type);
                return existingUser;
            } else if (data.success === false) {
                toast.error(data.message);
                eraseCookie("token");
            }
        } catch (error) {
            console.log(error);
        }
    };

    
  const sendMessage = (message) => {
    socket.emit("chat message", message);
  };


    useEffect(() => {
        dataAuth();
    }, []);

    useEffect(() => {
        getUserAllPro();
        getUserAllCat();
        getUserBlogs();
        getHeader();
        getTotalAmount()
        getData();
        getLocationHeader();
    }, []);



    return (
        <BlogContext.Provider value={{
            isLoading,sendMessage,AllMessages, Headers, isHeader,LocationHeaders, cartItems, getTotalUniqueItems, addItemToCart, removeItemFromCart, clearCart, updateItemQuantity,
            getTotalAmount, AllCategoriess, isLayoutLoading, layout,
            getTotalItems, applyPromoCode, AllProducts, clearAllItemsInCart, promoCodeInfo, removePromoCode, mypromoCode, totalAmount, PRELOADED_DATA
        }}>
            {children}
        </BlogContext.Provider>
    );
};

export const useBlogContext = () => {
    const context = useContext(BlogContext);
    if (!context) {
        throw new Error('useBlogContext must be used within a BlogProvider');
    }
    return context;
};
